import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { path, union, isEmpty } from "ramda";

import { documentsToDictionary, absolutePageToRelative } from "~/utils";

export const ADD_PRESENTATION_MARKER = "USER@PRESENTATION_MARKER::ADD";
export const ADD_PRESENTATION_MARKER_MULTIPLE =
  "USER@PRESENTATION_MARKER::ADD_MULTIPLE";
export const UPDATE_PRESENTATION_MARKER = "USER@PRESENTATION_MARKER::UPDATE";
export const REMOVE_PRESENTATION_MARKER = "USER@PRESENTATION_MARKER::REMOVE";

export const addPresentationMarker = createAction(ADD_PRESENTATION_MARKER);

export const addAllPresentationMarkers = createAction(
  ADD_PRESENTATION_MARKER_MULTIPLE
);
export const updatePresentationMarker = createAction(
  UPDATE_PRESENTATION_MARKER
);
export const removePresentationMarker = createAction(
  REMOVE_PRESENTATION_MARKER
);

const getPresentationMarkers = path(["user", "presentationMarkers"]);

export const selectPresentationMarkers = createSelector(
  getPresentationMarkers,
  markers => {
    return markers.map(marker => {
      const category = {
        isStatic: true,
        kind: "presentation_materials",
        title: "Präsentationsmodus",
        type: isEmpty(marker.pages) ? "book" : "page",
        view: "list",
        pages: marker.pages.map(page => absolutePageToRelative(page))
      };

      return {
        ...marker,
        categories: [category]
      };
    });
  }
);

export const selectPresentationMarkersLookup = createSelector(
  selectPresentationMarkers,
  documentsToDictionary
);

const initialState = () => [];

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case ADD_PRESENTATION_MARKER:
      return [...state, action.payload];
    case ADD_PRESENTATION_MARKER_MULTIPLE:
      return union(state, action.payload);
    case UPDATE_PRESENTATION_MARKER:
      return state.map(marker => {
        if (action.payload._id === marker._id) {
          return {
            ...marker,
            _rev: action.payload._rev || marker._rev,
            pages: action.payload.pages,
            book: action.payload.book
          };
        }
        return marker;
      });
    case REMOVE_PRESENTATION_MARKER:
      return state.filter(marker => marker.materialId !== action.payload);
    default:
      return state;
  }
}
